
import { Component, Inject, PLATFORM_ID } from '@angular/core'
import { LeaveSiteService } from 'src/app/core/services/leave-site.service'
import { isPlatformBrowser } from '@angular/common'
@Component({
    selector: 'app-leave-site',
    templateUrl: './leave-site.component.html',
    styleUrls: ['./leave-site.component.scss'],
    standalone: false
})
export class LeaveSiteComponent{
  constructor(
    public leaveSiteService: LeaveSiteService,
     @Inject(PLATFORM_ID) private platformId: object,
  ) {
    // this.logRouter(router)
  }
  cancelLeave() {
    this.leaveSiteService.showPopup = false
  }

  leave() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.leaveSiteService.showPopup = false
    if(this.leaveSiteService.onNewPage){
      window.open(this.leaveSiteService.url, '_blank')
    } else {
      document.location.href = this.leaveSiteService.url
    }
  }

}
